// src/components/ProtectedRoute.js
import { Navigate, Outlet } from 'react-router-dom';
import { auth } from '../firebase';

// General protected route for authenticated users
export const ProtectedRoute = ({ children }) => {
  const user = auth.currentUser;
  
  if (!user) {
    return <Navigate to="/" replace />;
  }
  
  return children ? children : <Outlet />;
};

// Admin-specific protected route
export const AdminProtectedRoute = ({ children }) => {
  const user = auth.currentUser;
  
  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }
  
  // Add additional admin verification here if needed
  // For example: if (!user.email.endsWith('@admin.com')) return <Navigate to="/" replace />;
  
  return children ? children : <Outlet />;
};

// Vendor-specific protected route
export const VendorProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('vendorBusiness');
  
  if (!user) {
    return <Navigate to="/vendor-login" replace />;
  }
  
  // Add additional vendor verification here if needed
  
  return children ? children : <Outlet />;
};

// Architect-specific protected route
export const ArchitectProtectedRoute = ({ children }) => {
  const architectData = JSON.parse(localStorage.getItem('architectData'));
  
  if (!architectData) {
    return <Navigate to="/architecture-login" replace />;
  }

  // Optional: Check for specific architect status (e.g., approved accounts only)
  // if (architectData.status !== 'active') {
  //   return <Navigate to="/architecture-pending" replace />;
  // }
  
  return children ? children : <Outlet />;
};

// Contractor-specific protected route
export const ContractorProtectedRoute = ({ children }) => {
  const contractorData = JSON.parse(localStorage.getItem('contractorData'));
  
  if (!contractorData) {
    return <Navigate to="/contractor-login" replace />;
  }

  // Optional: Check for specific contractor status
  // if (contractorData.status !== 'active') {
  //   return <Navigate to="/contractor-pending" replace />;
  // }
  
  return children ? children : <Outlet />;
};
